export default "__VITE_ASSET__CgwRi7Mj__"